import { render, staticRenderFns } from "./Decline.vue?vue&type=template&id=b5a7e6fe&"
import script from "./Decline.vue?vue&type=script&lang=js&"
export * from "./Decline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports